import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllCustomerResponse,
  getCustomerByIdResponse,
  changeMobileNumberResponse,
  getWishlistProductsResponse,
  addProductIdToWishlistResponse,
  getCartByCustomerIdResponse,
} from "../actions";

export function* createCustomerEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`customer`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Customer saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllCustomerEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`customer/all`));
    yield put(getAllCustomerResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    if (e?.status !== 401) {
      yield put(getAllCustomerResponse([]));
    }
  }
}

export function* getCustomerByIdEffectSaga(action) {
  console.log("saga triggers")
  console.log(action?.payload?.id)
  try {
    const { data } = yield call(() =>
      axiosGet(`customer/${action?.payload?.id}`)
    );
   
    yield put(getCustomerByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCustomerByIdResponse([]));
  }
}

export function* deleteCustomerEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`customer/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Customer deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* updateCustomerEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`customer/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Customer updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* changeMobileNumberEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`customer/change-Number?mobileNumber=9876543343&id=2`)
    );
    yield put(changeMobileNumberResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(changeMobileNumberResponse([]));
  }
}

export function* loginEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(
        `customer/login?userName=9876143210&password=12345`,
        action.data?.payload
      )
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Customer saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* validateOTPEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`user/validate/otp`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "OTP verified successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) {
      toast?.error("Invalid OTP.Please try again.");
      action.data?.callback?.failure?.(e);
    }
  }
}

export function* getWishlistProductsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`customer/wishlist/7`));
    yield put(getWishlistProductsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getWishlistProductsResponse([]));
  }
}

export function* addProductIdToWishlistEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`customer/wishlist/add?customerId=1&productId=1`)
    );
    yield put(addProductIdToWishlistResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(addProductIdToWishlistResponse([]));
  }
}

export function* getCartByCustomerIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`customer/cart/51`));
    yield put(getCartByCustomerIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCartByCustomerIdResponse([]));
  }
}

export function* updateProductQuantityFromCartEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`customer/cart/remove?customerId=7`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Customer saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateUserPasswordEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(
        `user/update/password?userName=${action?.data?.payload?.username}&newPassword=${action?.data?.payload?.password}`
      )
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "User password edited successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* removeProductFromCartEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`customer/remove-product?customerId=7`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Customer saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* customerWatcherSaga() {
  yield takeLatest(types.CREATE_CUSTOMER, createCustomerEffectSaga);
  yield takeLatest(types.GET_ALL_CUSTOMER, getAllCustomerEffectSaga);
  yield takeLatest(types.GET_CUSTOMER_ID, getCustomerByIdEffectSaga);
  yield takeLatest(types.DELETE_CUSTOMER, deleteCustomerEffectSaga);
  yield takeLatest(types.UPDATE_CUSTOMER, updateCustomerEffectSaga);
  // yield takeLatest(types.GET_CUSTOMER, changeMobileNumberEffectSaga);
  // yield takeLatest(types.CREATE_CUSTOMER, loginEffectSaga);
  yield takeLatest(types.VALIDATE_OTP, validateOTPEffectSaga);
  // yield takeLatest(types.GET_CUSTOMER, getWishlistProductsEffectSaga);
  // yield takeLatest(types.GET_CUSTOMER, addProductIdToWishlistEffectSaga);
  // yield takeLatest(types.GET_CUSTOMER, getCartByCustomerIdEffectSaga);
  // yield takeLatest(types.CREATE_CUSTOMER, updateProductQuantityFromCartEffectSaga);
  yield takeLatest(types.UPDATE_USER_PASSWORD, updateUserPasswordEffectSaga);
  // yield takeLatest(types.CREATE_CUSTOMER, removeProductFromCartEffectSaga);
}
